import * as types from "./types";

export const resetComparison = () => ({
    type: types.RESET_COMPARISON,
});

export const compare = ({ segments }) => ({
    type: types.COMPARE_WITH_MODEL,
    payload: { segments },
});

export const storeImageData = imageData => ({
    type: types.STORE_IMAGE_DATA,
    payload: imageData,
});

export const storeCanvas = canvas => ({
    type: types.STORE_CANVAS,
    payload: canvas,
});

export const selectModele = id => ({
    type: types.SELECT_MODELE,
    payload: id,
});

export const selectPosition = pos => ({
    type: types.SELECT_POSITION,
    payload: pos,
});

export const selectMotif = motif => ({
    type: types.SELECT_MOTIF,
    payload: motif,
});

export const selectNode = coord => ({
    type: types.SELECT_NODE,
    payload: coord,
});

export const removeTrace = () => ({
    type: types.REMOVE_TRACE,
});
